import RequiresAuth from '@website/components/auth/RequiresAuth';
import HostBusinessDetailsFormWrapper from '@website/components/hosts/signupForms/hostBusinessInfoUpdateForm';
import { GetServerSideProps } from 'next';
import { Container, Row, Col } from 'react-bootstrap';

type BusinessInfoUpdateFormProps = {
  urlSlug: string;
};

export default function BusinessInfoUpdatePage({
  urlSlug,
}: BusinessInfoUpdateFormProps) {
  return (
    <>
      <RequiresAuth>
        <Container className="p-4">
          <Row>
            <Col>
              <HostBusinessDetailsFormWrapper urlSlug={urlSlug} />
            </Col>
          </Row>
        </Container>
      </RequiresAuth>
    </>
  );
}

export const getServerSideProps: GetServerSideProps<
  BusinessInfoUpdateFormProps
> = async ({ query }) => {
  // use this to pass url params as props to the page, this prevents the weirdness
  // around the useRouter hook where you have to check whether the query params
  // are set.
  const { hostURL } = query;
  return {
    props: {
      urlSlug: hostURL as string,
    },
  };
};
